<template>
  <div class="row-fluid">
    <loading :active.sync="callingAPI" :can-cancel="false" loader="bars" color="#346cb0" :width="40" :is-full-page="fullPage"></loading>
    <div class="col-md-12 right-panel">
      <img src="assets/images/logo_onetrace.svg" alt="OneTrace" width="240">
      <div class="form-content width-small">
        <div class="row form-info text-center">
          <div class="col-12" style="color: #555555">
            <h4><strong>Need help with your Password?</strong></h4>
            <p>Enter the username you use for OneTrace, and we'll help you to reset your password.</p>
          </div>
        </div>

        <form class="login-form"  method="post">
          <div class="form-group" style="margin-bottom: 0;">
            <div class="input-group input-group-icon">
              <input id="username" name="username" type="text" class="form-control" v-model="username"
                     placeholder="Username" tabindex="1" required>
              <span class="input-group-addon">
                    <em class="fa fa-user"></em>
                </span>
            </div>
          </div>

          <div class="text-center" style="color: #555555">
            <p><small>If you forgot your username, <br> please contact our <a href="mailto:support@koltiva.com"
                                                                              class="primary-color">Customer Support
              Center</a></small></p>
          </div>

          <div class="form-group mt-40">
            <button type="submit" id="btnSubmit" class="btn btn-block st-button text-uppercase" @click="sendForgotPass">
              Request Verification Code
            </button>
          </div>
          <div class="horizontal-divider"><span style="color: #555555">or</span></div>
          <p class="text-center" style="color: #555555">
            <small>Have / Submit <a href="/change-password" class="primary-color" style="font-weight: bold;">verification
              code?</a></small>
          </p>

          <div class="form-text text-center mt-40" style="color: #555555">
            <em class="fa fa-long-arrow-alt-left"></em>
            <a href="/login" class="primary-color">
              Return to Login Page
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {urlApi} from '../../config/url-api'
import AxiosCall from "../../libs/AxiosCall";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: "ForgotPassword",
  components:{
    Loading
  },
  computed:{
    ...mapGetters(['callingAPI'])
  },
  data(){
    return {
      username:"",
      fullPage: true
    }
  },
  methods:{
    sendForgotPass(e){
      e.preventDefault()
      if(this.username == ""){
        this.$root.$children[0].errorMessage("Please fill out username !")
        return false
      }
      let payload = {
        username:this.username
      }
      this.$store.commit("TOGGLE_LOADING", true)
      AxiosCall.Post(payload,urlApi.auth.forgot_password).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$router.push({name:"ChallengePassword"})
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
        this.$store.commit("TOGGLE_LOADING", false)
      }).catch(err=>{
        this.$root.$children[0].errorMessage(err.response.data.message)
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.right-panel {
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.form-content.width-small {
  width: 400px;
}

.form-content {
  margin-top: 10px;
}

.form-info {
  margin: 10px 0 20px;
}

.form-info h4 {
  font-weight: 900;
}

.form-info h4, .form-info p {
  margin: 0;
}

h4, .h4 {
  font-size: 18px;
}

.input-group-addon {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  color: #555555;
  text-align: center;
  border-radius: 4px;
}

.primary-color {
  color: #EF7D22;
}

.st-button {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  background-color: #EF7D22;
  color: #f0f0f0;
  border-radius: 100px;
}

.text-uppercase {
  text-transform: uppercase;
}

.btn-block {
  display: block;
  width: 100%;
}

.horizontal-divider {
  width: 100%;
  height: 1px;
  border-top: 1px solid #ddd;
  margin: 20px 0;
}
.horizontal-divider span {
  background: #f3f5f4;
  position: relative;
  left: 45%;
  top: -12px;
  padding: 1px 10px;
}

.login-form .form-text {
  font-size: 13px;
}
.mt-40 {
  margin-top: 40px !important;
}
.text-center {
  text-align: center;
}

.vld-overlay{
  bottom:none !important;
  left: none !important;
}
</style>